import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { FormattedMessage } from 'react-intl';
import { Icon, Button } from '@atoms/index';
import colors from '@theme/colors';
import font from '@theme/font';
import styled from 'styled-components';
import onClickOutside from 'react-onclickoutside';
import moment from 'moment';
import momentDurationFormatSetup from 'moment-duration-format';
import messages from './messages';

momentDurationFormatSetup(moment);

const DownloadButton = styled(Button)`
  background-color: ${colors.PRIMARY};
  color: ${colors.WHITE};
  font-size: ${font.screen.size.MEDIUM};
  transition: 300ms;
  &:hover {
    background-color: ${colors.INTENSIVE};
  }
`;

const Wrapper = styled.span`
  display: block;
  position: relative;
  margin-right: 15px;
`;

const Tooltip = styled.div`
  position: absolute;
  left: 10px;
  top: 57px;
  background: ${colors.SECONDARY};
  border-radius: 4px;
  padding: 15px;
  width: 350px;
  box-shadow: 0.3em 0.3em 1em rgba(0, 0, 0, 0.3);
  transition: 300ms;
  :after {
    bottom: 100%;
    left: 11%;
    content: ' ';
    height: 0;
    width: 0;
    position: absolute;
    border-color: rgba(255, 255, 255, 0);
    border-bottom-color: #ffffff;
    border-width: 10px;
    margin-left: -10px;
  }
`;

const TooltipTitle = styled.div`
  color: ${colors.GREY};
`;

const AudioFile = styled.div`
  margin: 10px 0;
`;

const FileNameContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`;

const Duration = styled.div`
  color: ${colors.GREY};
  font-size: 12px;
`;

const audioDownloadIconStyle = {
  filter:
    'brightness(0) saturate(100%) invert(27%) sepia(74%) saturate(2029%) hue-rotate(167deg) brightness(98%) contrast(101%)',
};

const downloadIconStyleButton = { marginRight: '10px' };

class DownloadAudioButton extends PureComponent {
  state = {
    isTooltipOpen: false,
  };

  componentDidUpdate() {
    this.downloadFileOrShowTooltip();
  }

  downloadFileOrShowTooltip = () => {
    const { isFetching, recordings } = this.props;
    const { isTooltipOpen } = this.state;

    if (recordings.length === 0 || isFetching) return;

    // In case of one file only - immediately start download the file
    if (recordings.length === 1) {
      window.location.assign(recordings[0].url);
      return;
    }

    // Two or more files - just show tooltip with list of the files
    if (recordings.length >= 2 && !isTooltipOpen) {
      this.setState({
        isTooltipOpen: true,
      });
    }
  };

  // This method is used by HOC react-onclickoutside
  handleClickOutside = () => {
    this.props.clearAudioLinks();
    this.setState({
      isTooltipOpen: false,
    });
  };

  formatDuration = (seconds) =>
    moment.duration({ seconds }).format('HH [hours] mm [min] SS [s]');

  renderAudioFiles = () =>
    this.props.recordings.map(({ fileName, url, duration }) => (
      <AudioFile key={fileName}>
        <FileNameContainer>
          {fileName}{' '}
          <a href={url}>
            <Icon name="download" style={audioDownloadIconStyle} />
          </a>
        </FileNameContainer>
        <Duration>{this.formatDuration(duration)}</Duration>
      </AudioFile>
    ));

  render() {
    const { isFetching, getAudioLinksById } = this.props;
    const { isTooltipOpen } = this.state;

    return (
      <Wrapper>
        <DownloadButton onClick={getAudioLinksById} loading={isFetching}>
          <Icon name="download" style={downloadIconStyleButton} />
          <FormattedMessage {...messages.audioFile} />
        </DownloadButton>
        {isTooltipOpen && (
          <Tooltip>
            <TooltipTitle>
              <FormattedMessage {...messages.downloadAllFiles} />
            </TooltipTitle>
            {this.renderAudioFiles()}
          </Tooltip>
        )}
      </Wrapper>
    );
  }
}

DownloadAudioButton.propTypes = {
  getAudioLinksById: PropTypes.func.isRequired,
  clearAudioLinks: PropTypes.func.isRequired,
  isFetching: PropTypes.bool,
  recordings: PropTypes.array,
};

DownloadAudioButton.defaultProps = {
  recordings: [],
  isFetching: false,
};

export default onClickOutside(DownloadAudioButton);



// WEBPACK FOOTER //
// ./components/molecules/DownloadAudioButton/DownloadAudioButton.js